// Math shared by the Event Ops funnel cards: the "Signed up" count
// (SCRUM-449), the RSVP base later cards anchor on and the meet's athlete
// count (SCRUM-463). Kept out of EventOps.jsx, which pulls in
// axios via Services/arndAPI.js and can't be imported into a Jest test here
// (see src/App.test.js's pre-existing ESM failure for the same reason).

import eventAthletes from './eventAthletes.json';

/**
 * Everyone who got at least as far as signing up
 * during this event — leads (signed up, not joined) plus everyone who
 * joined (RSVP'd). `null` while leads data hasn't loaded yet, mirroring the
 * card's own '—' placeholder for that case.
 */
export const signedUpCount = (leads, joinedParents) =>
  leads ? leads.count + joinedParents : null;

/**
 * Percentage base + label for the athlete-counted cards (Signed up →
 * Purchased, SCRUM-487: f.athletes). With the meet's athlete count tracked
 * (eventAthletes.json) every one of them is a share of it, Signed up and
 * RSVPs included (`aboveRsvp`). Without it, the cards after RSVPs are
 * shares of RSVP'd athletes, and Signed up / RSVPs show no percentage.
 * QR scans and Installs never get one: they count scans and devices.
 */
export const funnelBase = (f, meet) =>
  meet
    ? { base: meet.athletes, baseLabel: 'of athletes', aboveRsvp: true }
    : { base: f.athletes.rsvp, baseLabel: 'of RSVPs', aboveRsvp: false };

/**
 * SCRUM-463: athletes competing at the meet, tracked by hand in
 * eventAthletes.json (keyed by event id) until it becomes an input on the
 * event page. `null` for an event with no entry — the Athletes card then
 * doesn't render.
 */
export const athleteCount = (eventId, table = eventAthletes) => table[eventId] ?? null;
